import script from "./ViewHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewHome.vue?vue&type=script&setup=true&lang=ts"

import "./ViewHome.vue?vue&type=style&index=0&id=6f0388be&lang=scss&scoped=true"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0388be"]])

export default __exports__